"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _UploadsUrlBuilder = _interopRequireDefault(require("../services/UploadsUrlBuilder"));
var TokenProvider = _interopRequireWildcard(require("../providers/TokenProvider"));
var _axios = _interopRequireDefault(require("axios"));
var _uploadConfig = _interopRequireDefault(require("../uploadConfig"));
var _uploadValidator = _interopRequireDefault(require("../services/uploadValidator"));
var _validationException = _interopRequireDefault(require("../exceptions/validation-exception"));
var _store = _interopRequireDefault(require("../store"));
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }
    newObj["default"] = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
var cimpressDefaultUploadUrl = 'uploads.documents.cimpress.io';
var cimpressUploadApiPlaceholder = '{uploadApi}';
var defaultTenant = 'printdeal-production-uploads';
var uploadUrl = {
  imageUploadUrl: 'https://{uploadApi}/v1/uploads?process={type:"image", "arguments":{"storeOriginal":"true"}}&tenant={tenant}',
  fileUploadUrl: 'https://{uploadApi}/v1/uploads?tenant={tenant}',
  pdfUploadUrl: 'https://{uploadApi}/v1/uploads?process={type:"storeOnly", "arguments": {"storeOriginal": true}}&tenant={tenant}',
  archiveUploadUrl: 'https://{uploadApi}/v1/uploads?process={type:"archiveOriginal"}&tenant={tenant}'
};
var CimpressUploadApi = /*#__PURE__*/
function () {
  /**
   * @constructor
   * @param {object | null} credentials to use for Cimpress calls
   * @param {string} cimpressUploadUrl to use as Cimpress domain
   * @param {string} tenant to use on Cimpress calls
   */
  function CimpressUploadApi(_ref) {
    var _ref$credentials = _ref.credentials,
      credentials = _ref$credentials === void 0 ? null : _ref$credentials,
      _ref$cimpressUploadUr = _ref.cimpressUploadUrl,
      cimpressUploadUrl = _ref$cimpressUploadUr === void 0 ? cimpressDefaultUploadUrl : _ref$cimpressUploadUr,
      _ref$tenant = _ref.tenant,
      tenant = _ref$tenant === void 0 ? defaultTenant : _ref$tenant;
    _classCallCheck(this, CimpressUploadApi);
    this.credentials = credentials; // separate it on upload and download links builder

    this.uploadsUrlBuilder = new _UploadsUrlBuilder["default"]({
      pdfUploadUrl: uploadUrl.pdfUploadUrl.replace(cimpressUploadApiPlaceholder, cimpressUploadUrl),
      imageUploadUrl: uploadUrl.imageUploadUrl.replace(cimpressUploadApiPlaceholder, cimpressUploadUrl),
      fileUploadUrl: uploadUrl.fileUploadUrl.replace(cimpressUploadApiPlaceholder, cimpressUploadUrl),
      archiveUploadUrl: uploadUrl.archiveUploadUrl.replace(cimpressUploadApiPlaceholder, cimpressUploadUrl),
      tenant: tenant
    });
  }
  /**
   * @param {File} file to be uploaded to Cimpress
   * @param {function} onUploadProgress method to be called or upload progress update
   * @param {CancelToken|null}cancelToken
   * @returns {Promise<AxiosResponse<any>>} response from Cimpress after upload
   * @throws axios exceptions
   */

  _createClass(CimpressUploadApi, [{
    key: "uploadFile",
    value: function uploadFile(file, onUploadProgress) {
      var cancelToken = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var formData = new FormData();
      formData.append('file', file);
      var validationErrors = CimpressUploadApi._validateFile(file);
      if (validationErrors.length !== 0) {
        return Promise.reject(validationErrors);
      }
      return this._getAxiosInstance().post(_uploadValidator["default"].getCorrectUrlFromUpload(this.uploadsUrlBuilder, file), formData, {
        headers: this._getDefaultHeaders(),
        onUploadProgress: onUploadProgress,
        cancelToken: cancelToken
      });
    }
    /**
     * @param {Array} files - array of files in format [{url, filename}, ...]
     * @param {CancelToken|null} cancelToken
     * @return {Promise<AxiosResponse<any>>} response from Cimpress after upload
     */
  }, {
    key: "generateArchive",
    value: function generateArchive(files) {
      var cancelToken = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var formData = new FormData();
      files.forEach(function (file) {
        formData.append('source', JSON.stringify(file));
      });
      return this._getAxiosInstance().post(this.uploadsUrlBuilder.getArchiveGenerationUrl(), formData, {
        headers: this._getDefaultHeaders(),
        cancelToken: cancelToken
      });
    }
    /**
     * @return {{"Content-Type": string}}
     * @private
     */
  }, {
    key: "_getDefaultHeaders",
    value: function _getDefaultHeaders() {
      return {
        'Content-Type': 'multipart/form-data'
      };
    }
    /**
     * @return {object} axios instance
     * @private
     */
  }, {
    key: "_getAxiosInstance",
    value: function _getAxiosInstance() {
      if (this.credentials && this.credentials.clientId) {
        return TokenProvider.getToken(this.credentials).then(function (token) {
          var instance = _axios["default"].create({
            headers: {
              authorization: token
            }
          });
          return CimpressUploadApi._addInterceptors(instance);
        });
      }
      var instance = _axios["default"].create();
      return CimpressUploadApi._addInterceptors(instance);
    }
    /**
     * @param {File} file to validate
     * @returns {Array} file can be uploaded
     * @private
     */
  }], [{
    key: "_validateFile",
    value: function _validateFile(file) {
      var errorMessages = [];
      if (file.size > _uploadConfig["default"].maxUploadSize) {
        errorMessages.push(_validationException["default"].size_limit);
      }
      if (!_uploadValidator["default"].isSupportedFile({
        files: [file]
      })) {
        errorMessages.push(_validationException["default"].filetype);
      }
      return errorMessages;
    }
    /**
     * @private
     * @param axiosInstance
     * @returns {object} axios instance
     */
  }, {
    key: "_addInterceptors",
    value: function _addInterceptors(axiosInstance) {
      axiosInstance.interceptors.request.use(function (config) {
        _store["default"].dispatch({
          type: 'INCREMENT_AMOUNT_OF_UPLOADS_IN_PROGRESS'
        });
        return config;
      });
      axiosInstance.interceptors.response.use(function (response) {
        _store["default"].dispatch({
          type: 'DECREMENT_AMOUNT_OF_UPLOADS_IN_PROGRESS'
        });
        return response;
      }, function (error) {
        _store["default"].dispatch({
          type: 'DECREMENT_AMOUNT_OF_UPLOADS_IN_PROGRESS'
        });
        return Promise.reject(error);
      });
      return axiosInstance;
    }
  }]);
  return CimpressUploadApi;
}();
exports["default"] = CimpressUploadApi;